import { useContext } from 'react';
import { DeleteModal, ModalContext } from 'dash-ui';

import { useDeleteMediaFilesMutation } from 'gql/generated.graphql';
import { isNil } from 'lodash';

const DeleteMediaFilesModal = ({
  onCompleted,
}: {
  onCompleted: () => void;
}) => {
  const { payload } = useContext(ModalContext);
  const [deleteMediaFiles, { loading }] = useDeleteMediaFilesMutation();

  const { mediaIds = [], filter, excludedIds } = payload || {};

  const onSubmit = async () => {
    const hasNotFilter = isNil(filter) || Object.keys(filter).length === 0;
    await deleteMediaFiles({
      variables: {
        mediaFilesIds: mediaIds,
        excludedIds,
        ...(!hasNotFilter &&
          (filter.fileTypes.length > 0 || !!filter.searchText) && { filter }),
      },
      onCompleted: () => {
        onCompleted();
      },
    });
  };

  return (
    <DeleteModal
      entity="Media File"
      name={payload?.name}
      isLoading={loading}
      modalName="BulkDeleteMediaModal"
      onClick={onSubmit}
      colorVariation="danger"
    />
  );
};

export default DeleteMediaFilesModal;
